export function truncate<K extends string>(text: K, maxLength: number, suffix = '...'): string {
  return text.length > maxLength ? `${text.substring(0, maxLength)}${suffix}` : text
}
